module.exports = __webpack_public_path__ + "img/016.6dc29950.jpg";